import { type FC, memo } from "react";
import { DataTestIds } from "src/shared/constants/TestEnums";
import { seoTableSkeleton } from "./seo-table-skeleton.recipes";

export const SeoTableSkeleton: FC = memo(() => (
  <div className={seoTableSkeleton} aria-hidden="true" data-testid={DataTestIds.SeoTableSkeleton} />
));

SeoTableSkeleton.displayName = "SeoTableSkeleton";
